var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "20 34.606 159.999 126.634",
    viewBox: "20 34.606 159.999 126.634",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      #comp-kq9ag33l svg [data-color=\"1\"] {fill: #16163F;}\r\n      #comp-kq9ag33l svg [data-color=\"2\"] {fill: #DDBBFF;}\r\n      #comp-kq9ag33l svg [data-color=\"3\"] {fill: #9E3FFD;}\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    fillRule: "evenodd",
    d: "M60.163 40.369a5.763 5.763 0 1 1-11.526 0 5.763 5.763 0 0 1 11.526 0z",
    fill: "#000000",
    "data-color": 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.029 103.69l40.464 40.531a9.606 9.606 0 0 1 0 13.572l-.627.628a9.604 9.604 0 0 1-13.583.011l-.011-.011-40.465-40.531a9.606 9.606 0 0 1 0-13.572l.627-.628a9.604 9.604 0 0 1 13.583-.011c.005.003.008.007.012.011z",
    fill: "#E7E7EB",
    clipRule: "evenodd",
    fillRule: "evenodd",
    "data-color": 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.556 144.076L162.971 43.492a9.604 9.604 0 0 1 13.583-.011l.011.011.627.628a9.606 9.606 0 0 1 0 13.572L76.777 158.276a9.604 9.604 0 0 1-13.583.011l-.011-.011-.627-.628a9.604 9.604 0 0 1 0-13.572z",
    fill: "#9E3FFD",
    clipRule: "evenodd",
    fillRule: "evenodd",
    "data-color": 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon1);
export default __webpack_public_path__ + "static/media/ServiceIcon1.72ea2a34afe7f2aa7ba17a349a9a9090.svg";
export { ForwardRef as ReactComponent };